function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "38",
  height: "44",
  viewBox: "0 0 38 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1_181)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.624 16.547c4.293 0 7.773-3.542 7.773-7.911 0-4.37-3.48-7.911-7.773-7.911-4.292 0-7.772 3.542-7.772 7.91 0 4.37 3.48 7.912 7.772 7.912z",
  fill: "#4242EC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 34.868c0-8.223 6.545-14.885 14.624-14.885 8.08 0 14.625 6.662 14.625 14.885",
  fill: "#4242EC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.628 34.488c4.21 0 7.623-3.473 7.623-7.759 0-4.285-3.413-7.759-7.623-7.759-4.21 0-7.623 3.474-7.623 7.76 0 4.285 3.413 7.758 7.623 7.758zM35.968 41.657l-6.678-8.79",
  stroke: "#C9D9FF",
  strokeWidth: "4.9",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_181"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .725)",
  d: "M0 0h38v43H0z"
}))));